
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","viewBox":"0 0 30 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h30v20H0V0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M16.9 0h-3.8v8.1H0v3.8h13.1V20h3.8v-8.1H30V8.1H16.9V0z","fill":"#D80027"}}),_c('path',{attrs:{"d":"M23.1 13.5l6.9 3.8v-3.8h-6.9zm-4.8 0L30 20v-1.8l-8.4-4.7h-3.3zm8.6 6.5l-8.6-4.8V20h8.6z","fill":"#00247D"}}),_c('path',{attrs:{"d":"M18.3 13.5L30 20v-1.8l-8.4-4.7h-3.3z","fill":"#fff"}}),_c('path',{attrs:{"d":"M18.3 13.5L30 20v-1.8l-8.4-4.7h-3.3z","fill":"#D80027"}}),_c('path',{attrs:{"d":"M5.3 13.5L0 16.4v-2.9h5.3zm6.4.8V20H1.5l10.2-5.7z","fill":"#00247D"}}),_c('path',{attrs:{"d":"M8.4 13.5L0 18.2V20l11.7-6.5H8.4z","fill":"#D80027"}}),_c('path',{attrs:{"d":"M6.9 6.5L0 2.7v3.8h6.9zm4.8 0L0 0v1.8l8.4 4.7h3.3zM3.1 0l8.6 4.8V0H3.1z","fill":"#00247D"}}),_c('path',{attrs:{"d":"M11.7 6.5L0 0v1.8l8.4 4.7h3.3z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.7 6.5L0 0v1.8l8.4 4.7h3.3z","fill":"#D80027"}}),_c('path',{attrs:{"d":"M24.7 6.5L30 3.6v2.9h-5.3zm-6.4-.8V0h10.2L18.3 5.7z","fill":"#00247D"}}),_c('path',{attrs:{"d":"M21.6 6.5L30 1.8V0L18.3 6.5h3.3z","fill":"#D80027"}})])
          )
        }
      }
    